// Google map key is also placed hardcoded in public/index.html
export const GOOGLE_MAP_KEY = "AIzaSyDofIWBUowJ1Lu6VgQjtx4nEVkTwOFBzYo";
export const GIFTCARD_CONFIG_KEY = "GiftCardConfig";
export const PROMO_GIFTCARD_CONFIG_KEY = "PromotionalGiftCardConfig";


export const MEET_PROVIDER = "Google"